<!-- <div class="content" role="main"> -->

<div class="clr-footer">
  <i>
    Made with <clr-icon shape="heart" class="is-solid is-error"></clr-icon> in
    Chicago
  </i>
  <!-- <a href="https://github.com/ravioshankar/GISGurus" target="_blank" rel="noopener">
  Give our repo a <clr-icon shape="star" class="is-solid is-warning" ></clr-icon>
     
    </a> -->
  <!-- 
    <a href="https://github.com/ravioshankar/GISGurus" target="_blank" rel="noopener">
      <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#1976d2"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    </a> -->
  <!-- </div> -->
</div>
